import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { detect } from 'detect-browser';
import OnVisible, { setDefaultProps } from 'react-on-visible';
import EllipsisText from 'react-ellipsis-text';

setDefaultProps({
    bounce: true,
    visibleClassName: 'appear',
    percent: 100,
});

import { fetchBtsWp } from '../requests/bts_request';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';

class BTS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            max_char: 140,
        };
    }

    scrollToTop(scrollDuration) {
        const scrollHeight = window.scrollY,
            scrollStep = Math.PI / (scrollDuration / 15),
            cosParameter = scrollHeight / 2;
        var scrollCount = 0,
            scrollMargin,
            scrollInterval = setInterval(function () {
                if (window.scrollY !== 0) {
                    scrollCount += 1;
                    scrollMargin =
                        cosParameter -
                        cosParameter * Math.cos(scrollCount * scrollStep);
                    window.scrollTo(0, scrollHeight - scrollMargin);
                } else clearInterval(scrollInterval);
            }, 15);
    }

    componentDidMount() {
        document.title = `Behind the scenes - Friends for Brands`;
        const browser = detect();
        if (browser.name === 'ie') {
            window.scrollTo(0, 0);
        } else {
            this.scrollToTop(1000);
        }
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        if (willMount) {
            this.props.fetchBtsWp();
        }
    }

    renderPosts() {
        if (this.props.btswp.btswp) {
            return this.props.btswp.btswp.map((item) => {
                if (item.posttype === 'feed') {
                    return (
                        <div key={item.wp_id} className="item insta fadeIn">
                            <img src={item.image} alt={item.caption} />
                            <p>
                                <EllipsisText
                                    text={item.caption || ''}
                                    length={163}
                                />
                            </p>
                        </div>
                    );
                } else {
                    if (item.hasFeaturedImage === true) {
                        return (
                            <div
                                key={item.wp_id}
                                className="item wp-big image-bg fadeIn">
                                <img src={item.image} alt={item.title} />
                                <div className="title-container">
                                    <h2>{item.title}</h2>
                                    <Link
                                        className="cta-btn white"
                                        to={{
                                            pathname: `/${item.posttype}/${item.slug}`,
                                            state: { transition: 'fade' },
                                        }}>
                                        Artikel lezen
                                    </Link>
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <div
                                key={item.wp_id}
                                className="item wp-wide fadeIn">
                                <div className="item-wrapper">
                                    <div className="title-container">
                                        <h2>{item.title}</h2>
                                        <Link
                                            className="cta-btn blue"
                                            to={{
                                                pathname: `/${item.posttype}/${item.slug}`,
                                                state: { transition: 'fade' },
                                            }}>
                                            Artikel lezen
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                }
            });
        } else {
            return '';
        }
    }

    render() {
        let browser = detect();
        browser = browser.name;
        return (
            <div className="bts page overviewpage">
                <main>
                    <Header />
                    <div id="main-container">
                        <div className="content-container">
                            <header className="intro-header">
                                <div className="two-col">
                                    <h1>Behind the scenes</h1>
                                </div>
                                <div className="two-col">
                                    <p className="intro">
                                        Creative, effective and friendly work is
                                        not created from thin air. Explore how
                                        we keep ourselves inspired and what
                                        inspires us.
                                    </p>
                                </div>
                            </header>
                            <div className="clearfix" />
                            <Link
                                to={{
                                    pathname: '/work',
                                    state: { transition: 'slideRight' },
                                }}
                                className="nav-btn">
                                <i className="icon icon-arrow_right" />
                                <span>Work</span>
                            </Link>
                            <Loader
                                loaded={
                                    this.props.btswp.fetched ||
                                    this.props.btswp.failed
                                }
                            />
                            <div
                                id="feed-container"
                                className={
                                    browser === 'ie' ? 'ie-browser' : ''
                                }>
                                {this.renderPosts()}
                            </div>
                            {this.props.btswp.failed && (
                                <h2>
                                    :(!
                                    <br />
                                    Something went wrong. Try it again later.
                                    <br />
                                    <br />
                                </h2>
                            )}
                            <OnVisible className="not-appeared">
                                <div className="overviewpage__link-container">
                                    <a
                                        href="https://www.instagram.com/friendsforbrands/"
                                        target="_blank"
                                        className="cta-btn white">
                                        Follow us
                                    </a>
                                </div>
                            </OnVisible>
                        </div>
                    </div>
                    <Footer type="bts" />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ btswp }) {
    return { btswp };
}

export default withRouter(connect(mapStateToProps, { fetchBtsWp })(BTS));



// WEBPACK FOOTER //
// ./src/containers/BTS.jsx